export const mapAccount = (item) => item.account || 'None';

export const mapGroup = item => item.accountGroup || 'None';

export const mapRepOwner = ({ repOwnerData }) => (
  repOwnerData
    ? `${repOwnerData?.firstName} ${repOwnerData?.lastName}`
    : 'None'
);
